import { render } from "./TablaAdTrans.vue?vue&type=template&id=ddd8ba6e&scoped=true"
import script from "./TablaAdTrans.vue?vue&type=script&lang=js"
export * from "./TablaAdTrans.vue?vue&type=script&lang=js"

import "./TablaAdTrans.vue?vue&type=style&index=0&id=ddd8ba6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd8ba6e"]])

export default __exports__